module.exports = __webpack_public_path__ + "static/media/skin-care.c9631e7a.webp";